// @ts-nocheck
import {Column} from 'react-table'
import {UserLastLoginCell} from './UserLastLoginCell'
import {UserTwoStepsCell} from './UserTwoStepsCell'
import {UserActionsCell} from './UserActionsCell'
import {UserSelectionCell} from './UserSelectionCell'
import {UserCustomHeader} from './UserCustomHeader'
import {UserSelectionHeader} from './UserSelectionHeader'
import {User} from '../../core/_models'
import {Pricecopy} from './Pricecopy'
import {Idcell} from './idcell'

const usersColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => <UserSelectionHeader tableProps={props} />,
    id: 'selection',
    Cell: ({...props}) => <UserSelectionCell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Groupjob#' className='min-w-125px' />
    ),
    accessor: 'jobGroupId',
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Quote#' className='min-w-125px' />,
    id: 'id',
    Cell: ({...props}) => <Idcell id={props.data[props.row.index].id} />,
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Creation Date' className='min-w-125px' />,
    id: 'created',
    Cell: ({...props}) => <UserLastLoginCell created={props.data[props.row.index].created} />,
  },

  {
    Header: (props) => <UserCustomHeader tableProps={props} title='price' className='min-w-125px' />,
    id: 'price',
    Cell: ({...props}) => <Pricecopy price={props.data[props.row.index].price} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Status' className='min-w-125px' />
    ),
    id: 'isAccepted',
    Cell: ({...props}) => <UserTwoStepsCell count={props.data[props.row.index].count}  isAccepted={props.data[props.row.index].isAccepted} />,
  },

  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
  //   ),
  //   id: 'actions',
  //   Cell: ({...props}) => <UserActionsCell id={props.data[props.row.index].id} />,
  // },
]

export {usersColumns}
